import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { CHATTER_LESSON_PLANS } from "config/paths";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import { MIME_TYPES, STATUS_OPTIONS } from "config/constants";
import addLessonSchema from "../addLesson.schema";
import { cloneDeep, isEmpty } from "lodash";
import { useAddLessonMutation, useDeleteLessonFileMutation, useEditLessonMutation, useGetChatterLessonTagsQuery, useGetLessonDetailsQuery } from "store/services/lesson";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast } from "helpers/common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import LoadingButton from "components/shared/LoadingButton";
import chatterLessonValidation from "../addLesson.schema";

const ChatterLessonPlanAdd = () => {

  const { id: lessonId } = useParams();
  const editMode = !!lessonId;

  const { data: lessonDetails, isLoading } = useGetLessonDetailsQuery(lessonId, { skip: !lessonId });

  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({ title: "", files: [], tags: [], description: "", status: STATUS_OPTIONS?.find(x => x.value == "active") });
  const [showModal, setShowModal] = useState();
  const [currentEntry, setCurrentEntry] = useState(null);

  const [addLesson, { isLoading: addLessontLoading }] = useAddLessonMutation();
  const [updateLesson, { isLoading: updateLessonLoading }] = useEditLessonMutation();
  const [deleteFile, { isLoading: deleteLessonLoading }] = useDeleteLessonFileMutation();
  const { data: lessonTags, isLoading: lessonTagsLoading } = useGetChatterLessonTagsQuery()

  const handleAttachDocument = (name, value, prevValues, setFieldValue) => {
    try {
      let cloneValues = cloneDeep(prevValues);
      cloneValues.push({
        attachment_key: value,
        attachment_name: value,
      })
      setFieldValue(name, cloneValues);
    } catch (err) {
      console.error("Failed to attach document", err);
    }
  };

  const handleSubmit = async (payload) => {

    try {

      let values = cloneDeep(payload);
      values.status = payload?.status?.value;

      const result = editMode ? await updateLesson({ data: values, lessonId }) : await addLesson(values);
      if (result?.error) return

      successMessageToast(result?.data?.message);
      navigate(CHATTER_LESSON_PLANS);

    } catch (err) {
      console.error("Error adding lesson", err);
    }
  };

  useEffect(() => {

    if (!lessonId) return;

    if (lessonDetails) {
      setInitialValues({
        title: lessonDetails?.title || "",
        files: lessonDetails?.files || "",
        tags: lessonDetails?.lessonTags?.length ? lessonDetails?.lessonTags?.map((item) => item?.tag_id) : [],
        description: lessonDetails?.description || "",
        status: STATUS_OPTIONS?.find(x => x.value == lessonDetails?.status)
      })
    }
  }, [lessonDetails]);

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const result = await deleteFile(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting files", err);
    };
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        type="delete"
        confirmHandler={handleDelete}
      />

      <section className={`${styles.addForm} position-relative py-4 addForm h-100`}>
        <Container className="h-100">
          {(isLoading || lessonTagsLoading) ? <LoadingIndicator /> : <Row className="h-100">
            <Col lg="12" className="my-2">
              {deleteLessonLoading && <LoadingOverlay />}
              <div className="pageHead pb-3">
                <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Chatter Lesson" : "Add Chatter Lesson"}</h6>
              </div>
              {/* <Formik
                initialValues={initialValues}
                validationSchema={addLessonSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {
                  ({
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    submitCount
                  }) => (
                    <Form className="chatter-lesson-wrapper d-flex flex-column" onSubmit={handleSubmit}>
                      <div
                        className="py-3"
                      >
                        <Row>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0"
                            >
                              Add Lesson Name
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              name="title"
                              type="text"
                              placeholder="Enter Title"
                              className={`${styles.formControl} form-control`}
                              maxLength={100}
                            />
                          </Col>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0"
                            >
                              Add Description
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              name="description"
                              fieldType={"textarea"}
                              placeholder=""
                              className={`${styles.formControl} form-control`}
                              maxLength={500}
                            />
                          </Col>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0"
                            >
                              Add Tag
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              name="tag"
                              type="text"
                              placeholder="Enter Tag"
                              className={`${styles.formControl} form-control`}
                              maxLength={100}
                            />
                          </Col>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0"
                            >
                              Attach Documents
                              <RequiredFieldAstrick />
                            </label>
                            <AppFileUploadField
                              name="files"
                              acl={"private"}
                              accept="application/pdf"
                              allowedTypes={[MIME_TYPES.pdf]}
                              className={`${styles.formControl} form-control`}
                              handleRemove={(file) => {
                                if (editMode) {
                                  setShowModal(true);
                                  setCurrentEntry(file);
                                }
                              }}
                              onChange={(name, value) => {
                                handleAttachDocument(name, value, values?.files, setFieldValue);
                              }}
                            />
                          </Col>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0"
                            >
                              Status
                              <RequiredFieldAstrick />
                            </label>
                            <CommonSelect
                              name="status"
                              placeholder={"Please Select Status"}
                              option={STATUS_OPTIONS}
                            />
                          </Col>
                        </Row>
                      </div>
                      <Row className="mt-auto ">
                        {(!isEmpty(errors) && submitCount > 0) && (
                          <Row className="my-2">
                            <Col lg="12">
                              <span className="error">{genericFormErrorMsg}</span>
                            </Col>
                          </Row>
                        )}
                        <Col className="my-2" lg="12">
                          <div
                            className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                            style={{ borderTop: "1px solid #41a2a84d" }}
                          >
                            <Button
                              className="d-flex align-items-center justify-content-center commonBtn"
                              type="submit"
                              disabled={addLessontLoading || updateLessonLoading}
                            >
                              {
                                addLessontLoading || updateLessonLoading ? <LoadingIndicator /> : "Save"
                              }

                            </Button>
                            <Button
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                              type="button"
                              onClick={() => navigate(CHATTER_LESSON_PLANS)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
              </Formik> */}
              <Formik
                initialValues={initialValues}
                validationSchema={chatterLessonValidation}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  errors,
                  values,
                  touched,
                  setFieldTouched
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="reports-v2">
                      <div className=" d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                        {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6> */}
                      </div>
                      <Row >
                        <Col md="8" className="my-2 name-input-v2">
                          <label
                            htmlFor=""
                            className="discharge-screen-label mt-0"
                          >
                            Lesson Name
                            <RequiredFieldAstrick />
                          </label>
                          <AppInputField
                            name="title"
                            className={`${styles.formControl} readonly-box h-auto`}
                            styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                            placeholder="Enter lesson name"
                          />
                        </Col>
                        <Col md="8" className="mt-2">
                          <label
                            htmlFor=""
                            className="discharge-screen-label mt-0"
                          >
                            Description
                            <RequiredFieldAstrick />
                          </label>
                          <div className="editor-paren-v2">
                            <CustomEditor style={{ borderRadius: 0 }} name={`description`} />
                          </div>
                          {/* <CKEditorField
                        items={[
                          'bold',
                          'italic',
                          'underline',
                          'alignment',
                          '|',
                          'bulletedList',
                          'numberedList',
                        ]}
                        value={values?.answers}
                        handleChange={(event, editor) => {
                          setFieldValue(`answers`, editor?.getData());
                        }}
                      /> */}
                        </Col>
                        <Col md="8" className="my-2">
                          <label className="discharge-screen-label mt-0 mb-0">
                            Tag
                            <RequiredFieldAstrick />
                          </label>

                          <div className="d-flex area-pills flex-wrap gap-2 mt-2 mb-2">
                            {lessonTags?.records?.map((tag) => (
                              <button
                                key={tag?.id}
                                type="button"
                                // variant={values.tags?.includes(tag?.value) ? "primary" : "outline-secondary"}
                                className={values.tags?.includes(tag?.id) ? "select-liberary-btn proxima-regular" : "non-select-liberary-btn proxima-regular"}
                                onClick={() => {
                                  setFieldTouched('tags')
                                  if (values.tags?.includes(tag?.id)) {
                                    setFieldValue(
                                      "tags",
                                      values.tags.filter((t) => t !== tag?.id)
                                    );
                                  } else {
                                    setFieldValue("tags", [...(values.tags || []), tag?.id]);
                                  }
                                }}
                              >
                                {tag?.title}
                              </button>
                            ))}
                          </div>
                          {(touched?.tags && errors?.tags) ? (
                            <div className="error">{errors?.tags}</div>
                          ) : null}
                        </Col>
                        <Col md="4" sm="6" className="my-2"></Col>
                        <Col md="4" sm="6" className="my-2">
                          <label className="discharge-screen-label mt-0 mb-0">
                            Attach Documents
                            <RequiredFieldAstrick />
                          </label>
                          <AppFileUploadField
                            name="files"
                            acl={"private"}
                            accept="application/pdf"
                            allowedTypes={[MIME_TYPES.pdf]}
                            className={`${styles.formControl} readonly-box h-auto`}
                            onChange={(name, value) => {
                              handleAttachDocument(name, value, values?.files, setFieldValue);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="btnWrpper mt-2 text-end d-flex justify-content-end">
                      <LoadingButton
                        type="submit"
                        className="blue-discharge-screen-btn"
                        isLoading={isSubmitting}
                      >
                        Submit
                      </LoadingButton>

                      {/* <LoadingButton
                  type="button"
                  className="blue-discharge-screen-btn"
                  onClick={() => { addToReport(values); closePopup(); }}
                  isLoading={isSubmitting}
                >
                  Add to Report
                </LoadingButton> */}
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default ChatterLessonPlanAdd;
